<template>
  <div class="project-account-manage app-panel blank-h">
    <div class="app-control app-table-control">
      <el-button type="primary" @click="add">新增账号</el-button>
      <div class="right-region">
        <el-input placeholder="请输入名称" v-model="search.value" clearable></el-input>
        <el-button type="primary" @click="searchParams">搜索</el-button>
        <el-button @click="resetParams">重置</el-button>
      </div>
    </div>
    <el-table :data="datas" v-loading="loading">
      <el-table-column label="手机号" prop="account_attr_data.account_attr_phone"></el-table-column>
      <el-table-column label="名称" prop="account_attr_data.account_attr_name"></el-table-column>
      <el-table-column label="职位" prop="account_attr_data.account_attr_title"></el-table-column>
      <el-table-column label="权限" prop="auth"></el-table-column>
      <!-- <el-table-column label="状态" prop="status"></el-table-column> -->
      <el-table-column label="操作">
        <template slot-scope="{row}">
          <el-button type="text" @click="edit(row.account_id)">编辑</el-button>
          <el-button type="text" @click="del(row.account_id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination :total="page.total" :page-size="page.pageSize" :current-page="page.currentPage" @current-change="currentChange" background></el-pagination>
  </div>
</template>

<script>
  import AccountService from '@/io/account.js';

  export default {
    name: 'AccountManage',
    data() {
      return {
        search: {
          value: ''
        },
        datas: [],
        loading: false,
        page: {
          pageSize: 0,
          total: 0,
          currentPage: 1
        }
      }
    },
    mounted() {
      this.initDatas();
    },
    methods: {
      initDatas() {
        this.loading = true;
        AccountService.listPage(
          this.page.currentPage,
          this.search.value
        ).then(res => {
          let source = res.data;
          if (!source.data.length && this.page.currentPage > 1) {
            this.page.currentPage--;
            this.initDatas();
          } else {
            this.datas = source.data.map(val => {
              val.status = val.account_status === 1 ? '开启' : '关闭';
              val.auth = val.account_permission_data.map(m => {
                return m.menu_name;
              }).join('、');
              return val;
            });
            this.page.pageSize = source.per_page;
            this.page.total = source.total;
          }
        }).catch(() => {}).finally(() => {
          this.loading = false;
        });
      },
      add() {
        this.$router.push({
          path: '/account_manage/new'
        });
      },
      edit(id) {
        this.$router.push({
          path: `/account_manage/edit/${id}`
        });
      },
      del(id) {
        this.$confirm(
          '确认删除?',
          '提示',
          {
            type: 'warning'
          }
        ).then(() => {
          return AccountService.del(id);
        }).then(res => {
          return this.initDatas();
        }).then(res => {
          this.$message.success('删除成功');
        }).catch(() => {});
      },
      currentChange(page) {
        this.page.currentPage = page;
        this.initDatas();
      },
      searchParams() {
        this.page.currentPage = 1;
        this.initDatas();
      },
      resetParams() {
        this.search.value = '';
        this.searchParams();
      }
    },
  }
</script>

<style lang="less" scoped>

</style>